module.exports = __webpack_public_path__ + "img/15.58ce4dd1.png";